/**
 * Created by murat on 9/27/2016.
 */
import {Injectable} from '@angular/core';
import { Observable, Subject, empty } from 'rxjs';
import {User} from '@slarys/ufe-models';
import {AppSettings} from '@slarys/ufe-config';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class AccountService {
  private _users: Observable<Array<User>>;
  private _user: Observable<User>;
  private _loggedInUser: User;
  private newUserSignupSubject = new Subject<any>();
  private loggedOut = new Subject<any>();
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  constructor(private http: HttpClient) {
  }

  public getMissedTaggedCorporateUsers (page: number): Observable<any> {
    let url = AppSettings.API_ENDPOINT + '/users/missed-tagged-corporate';
    url += '?page=' + page;

    return this.http.get(url);
  }

  // Admin only

  public getCorporateUsers (page: number, query?: string): Observable<any> {
    let url = AppSettings.API_ENDPOINT + '/users/corporate?search=' + query;
    url += '&page=' + page;

    return this.http.get(url);
  }

  public getEndUsers (page: number, query?: string): Observable<any> {
    let url = AppSettings.API_ENDPOINT + '/users/end?search=' + query;
    url += '&page=' + page;

    return this.http.get(url);
  }

  public getUsers (type: string, page: number, query?: string): Observable<any> {
    if (type === 'users') {
      return this.getEndUsers(page, query);
    } else {
      return this.getCorporateUsers(page, query);
    }
  }

  public getAllUsers (page: number): Observable<any> {
    let url = AppSettings.API_ENDPOINT + '/users';
    url += '?page=' + page;

    return this.http.get(url);
  }


  public getUser (id: string): Observable<any> {
    return this.http.get(AppSettings.API_ENDPOINT + '/users/' + id).pipe();
  }

  /**
   * @deprecated Use getUser instead. Will be deleted.
   */
  public getExpandedUser(user: User) {
    return this.http
      .get<User>(
        AppSettings.API_ENDPOINT + '/users/' + user.id,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public getUsersToday() {
    return this.http
      .get<any>(
        AppSettings.API_ENDPOINT + '/users/count-today',
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }

  public updateUser(user: User) {
    return this.http
      .put<User>(
        AppSettings.API_ENDPOINT + '/users/' + user.id,
        user,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }
}
